import dayjs from "dayjs";

import { Bold, Value } from "@components/Text";

const LABEL_NEXT_DATE = "Next Date";
const DATE_FORMAT = "MM/DD/YYYY";

type Props = {
  nextDate?: string;
  totalAmount?: number;
}

const DistributionsScheduleSummary = ({ nextDate = undefined, totalAmount = undefined }: Props) => {
  if (!nextDate) {
    return null;
  }

  const value = dayjs(nextDate).format(DATE_FORMAT);

  return (
    <span>
      {`${LABEL_NEXT_DATE}:`} <Bold>{value}</Bold>
      {
        totalAmount && (
          <span>{' for '}<Value value={totalAmount} /></span>
        )
      }
    </span>
  );
};

export default DistributionsScheduleSummary;
